import { cn } from '@/utils/cn';

interface BackArrowProps {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  variant?: string;
}

const BackArrow = ({
  onClick,
  className,
  disabled = false,
}: BackArrowProps) => {
  return (
    <button
      className={cn(
        'p-2.5 z-10 bg-white/80 backdrop-blur-sm rounded-full shadow-md hover:shadow-lg hover:bg-white transition-all',
        'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      aria-label="بازگشت"
      type="button"
    >
      <svg
        className="w-6 h-6 text-gray-700"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth="2.5"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
  );
};

export default BackArrow;

